import { Home, Info, Building2, Factory, Mail, LayoutPanelTop, Newspaper, Contact } from "lucide-react";

const constants = {
  API: {
    S3_BASE_URL: "https://6ea9cd62028d1658eb4e59bd82d253bc.r2.cloudflarestorage.com/rasa-enclave/",
    API_BASE_URL: "https://backend.rasaenclave.com/api",
    // API_BASE_URL: "http://localhost:3002/api",
  },
  USER_ROLES: { ADMIN: "admin", },
  COLOR: { PRIMARY: "#393188", },
  MESSAGES: {
    REQUIRED_FIELD: "This field is required",
    SUCCESS: "Success",
    DATA_IS_UPDATED_SUCCESSFULLY: "Data is updated successfully.",
    DATA_IS_ADDED_SUCCESSFULLY: "Data is added successfully.",
    FAILED: "Failed",
    INVALID_CREDS: "Please enter a valid email and password.",
    INVALID_EMAIL: "Please enter a valid email address.",
    INTERNAL_SERVER_ERROR: "Something went wrong. Please try again later.",
    SESSION_EXPIRED: "Your session has expired. Please login again.",
  },
  DATE_TIME_FORMATS: {
    DATE_FLATPICKER: "d-m-Y",
    DATE_FLATPICKER_CERT: "d/m/Y",
    DATE_UI: "DD-MM-YYYY",
    DATE_API: "YYYY-MM-DD",
    DATE_FULL_MONTH: "DD-MMM-YYYY",
    DATE_DAY: "day",
    DATE_DAYS: "days",
    FULL_MONTH: "MMM YYYY",
    TIME_12_HR: "h:mma",
    TIME_24_HR: "HH:mm",
    FULL_TIME: "HH:mm:ss",
  },
  BACK_BUTTON_SCREENS: [],
  MENU_ITEMS: {
    LAYOUT: [
      { id: 1, label: "Header", link: "/header-settings", icon: LayoutPanelTop },
      { id: 2, label: "Footer", link: "/footer", icon: LayoutPanelTop },
      { id: 3, label: "Leads", link: "/leads", icon: Mail },
    ],
    PAGES: [
      { id: 3, label: "Home", link: "/home", icon: Home },
      { id: 4, label: "About Us", link: "/aboutus", icon: Info },
      { id: 5, label: "Residential", link: "/residential", icon: Building2 },
      { id: 6, label: "Industrial", link: "/industrial", icon: Factory },
      { id: 7, label: "Blogs", link: "/blogs", icon: Newspaper },
      { id: 8, label: "Blog Page", link: "/blog-page", icon: Newspaper },
      { id: 9, label: "Contact Us", link: "/contact", icon: Contact },
    ],
    MASTER_PAGES: [],
    MISC: [],
  },

  USERS: {
    ADMIN: { id: "rasa@admin.com", pass: "rasa123#@!", role: "admin" },
  },

  getS3File: (url) => {
    const S3_BUCKET_URL = "https://strategysoda.s3.ap-south-1.amazonaws.com";
    return `${S3_BUCKET_URL}/${url}`;
  },

  STORAGE_KEYS: {
    USER: "user",
    TOKEN: "token",
  },
};

export default constants;
